import { useOpMutation } from '../useOpMutation';

export const useActivateMfaCredential = () =>
  useOpMutation({
    apiEndpointName: 'activateMfaCredential',
    queryKeysToInvalidate: [['listMfaCredentials']],
  });
